import { Github, Globe, Linkedin, Mail, MapPin, MessageCircle, Phone } from 'lucide-react';

const QUICK_LINKS = [
  { label: '首页', href: '#home' },
  { label: '核心产品', href: '#products' },
  { label: '安全服务', href: '#services' },
  { label: '服务案例', href: '#cases' },
  { label: '服务客户', href: '#clients' },
];

const SOCIAL_LINKS = [
  { label: '微信', icon: MessageCircle, href: '#home' },
  { label: '邮箱', icon: Mail, href: 'mailto:liuqiang@sewi.cn' },
  { label: '官网', icon: Globe, href: '#home' },
  { label: '领英', icon: Linkedin, href: '#home' },
  { label: 'GitHub', icon: Github, href: '#home' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/5 bg-slate-950">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌信息 */}
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/images/logo.png" alt="赛威安全 Logo" className="h-18 rounded-lg" />
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              专注人工智能、大数据与云计算领域的安全解决方案，为企业提供前沿技术支撑与
              7x24 小时专业保障，驱动数字化转型。
            </p>
          </div>

          {/* 快速链接 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-200">
              快速链接
            </h3>
            <ul className="mt-4 space-y-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-slate-400 transition-colors duration-300 hover:text-cyan-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-200">
              联系方式
            </h3>
            <ul className="mt-4 space-y-3.5">
              <li className="flex items-start gap-3 text-sm text-slate-400">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
                <a
                  href="mailto:liuqiang@sewi.cn"
                  className="transition-colors duration-300 hover:text-cyan-400"
                >
                  liuqiang@sewi.cn
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-400">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
                <a
                  href="tel:4009868616"
                  className="transition-colors duration-300 hover:text-cyan-400"
                >
                  4009 868 616
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
                <span>北京市海淀区西八里庄路明玉大厦12层</span>
              </li>
            </ul>
          </div>

          {/* 社交媒体 */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-slate-200">
              关注我们
            </h3>
            <div className="mt-4 flex flex-wrap gap-3">
              {SOCIAL_LINKS.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-slate-400 transition-all duration-300 hover:border-cyan-400/60 hover:text-cyan-400"
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-8 text-xs text-slate-500 md:flex-row">
          <p>
            © {year} 赛威安全 SAWISAFETY 版权所有
          </p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noreferrer"
            className="transition-colors duration-300 hover:text-cyan-400"
          >
            京ICP备2024096075号-1
          </a>
        </div>
      </div>
    </footer>
  );
}
